import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class TarefasHonraService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/tarefas/honra';
  }

  public alterarLimiteStopLoss(cnpjAgenteFinanceiro: string, ideTranche: number, anoMesReferencia:string, valorDisponivel: number ): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/alterar-limite-stop-loss/agente-financeiro/${cnpjAgenteFinanceiro}/tranche/${ideTranche}/data-ref/${anoMesReferencia}/valor-disponivel/${valorDisponivel}`, options).pipe
        (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public alterarEstadoSolicitacaoHonra(idSh: number, idEstado: string): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/alterar-estado/solicitacao-honra/${idSh}/estado/${idEstado}`, options).pipe
        (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public fecharJanelaSolicitacaoHonra(): Observable<any> {
    const options: any = blockUi();
    options.responseType = "text";
    return this.http.post(`${this.BASE_URL}/fechar-janela`, undefined, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public rodarStopLoss(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/rodar-stop-loss`, undefined, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public processarSolicitacoesHonraCreditoLivre(): Observable<any>  {
    const options: any = blockUi();
    options.responseType = "text";
    return this.http.post(`${this.BASE_URL}/processar-credito-livre`, undefined, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public processarSolicitacoesHonraCreditoLivreSemCriticas(idSh: number): Observable<any>  {
    const options: any = blockUi();
    options.responseType = "text";
    return this.http.post(`${this.BASE_URL}/processar-credito-livre-sem-criticas/${idSh}`, undefined, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public processarSolicitacoesHonraRepasse(): Observable<any> {
    const options: any = blockUi();
    options.responseType = "text";
    return this.http.post(`${this.BASE_URL}/processar-repasse`, undefined, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public processarSolicitacoesHonraRepasseSemCriticas(idSh: number): Observable<any>  {
    const options: any = blockUi();
    options.responseType = "text";
    return this.http.post(`${this.BASE_URL}/processar-repasse-sem-criticas/${idSh}`, undefined, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public simularPagamento(idSh: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/simular-pagamento/solicitacao-honra/${idSh}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public desfazerProcessamentoDeHonra(idSh: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/desfazer-processamento/solicitacao-honra/${idSh}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public removerSolicitacaoHonra(idSh: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/remover/solicitacao-honra/${idSh}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public monitorarPagamentoFaturas(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/monitorar-pagamento-faturas`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>
  }  

  public emitirExtratosPagamento(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/emitir-extratos-pagamento-honra`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>
  }

  public emitirRelatoriosValoresHonradosRecuperar(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/emitir-relatorios-valores-honrados-a-recuperar`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public emitirFaturas(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/emitir-faturas`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public emitirRelatoriosProvisaoPagamentos(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/emitir-relatorios-provisao-pagamentos`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public emitirRelatorioDefin(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/emitir-relatorio-defin`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public criarJanelaSolicitacaoHonra(anoMes: string|Date): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/janela-solicitacao-honra/${anoMes}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public consultarJanelaSolicitacaoHonra(anoMes: string|Date): Observable<any> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/janela-solicitacao-honra/${anoMes}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public criarSolicitacaoHonra(idOperacao: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/criar/solicitacao-honra/${idOperacao}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

}
